export default {"src":"/_next/static/media/cropped-logo.16bf423c.svg","height":56,"width":60,"blurWidth":0,"blurHeight":0};